const reviewerData = [
  {
    reviewerName: "Shubham Raj",
    reviewerAddress: "Gulzarbagh, Patna City",
    reviewerImage: "person1.jpeg",
    review:
      "A great app!!!😋😋 A very good and convenient option for buying products for daily purposes especially for the ones living in Patna. Everything is available at great offers.💯",
  },
  {
    reviewerName: "Aishani Kashyap",
    reviewerAddress: "Bhagwat Nagar, Patna",
    reviewerImage: "person2.jpeg",
    review:
      "Awesome App. Works really well; one can find anything here. Great app for online grocery shopping. Go for it !",
  },
  {
    reviewerName: "Vishal Abhishek",
    reviewerAddress: "Kankarbagh, Patna",
    reviewerImage: "person1.jpeg",
    review:
      "Good quality products and instant service. Smooth user interface of this app is obviously an add on,to instantly buy anything in a go.💯",
  },
  {
    reviewerName: "Pratyush Rai",
    reviewerAddress: "Bhootnath, Patna",
    reviewerImage: "person2.jpeg",
    review:
      "Good services, fresh and hygienic item 😋😋😋😋and fastest delivery",
  },
]

export default reviewerData
